import m from 'mithril'
import moment from 'moment'
import BaseModel from './_base'

let _data = []

const constraints = {
    name: {
        presence: {
            allowEmpty: false,
            message: "^請輸入名稱"
        }
    },
}
class Module extends BaseModel {

    constructor(args) {
        super(constraints)
        args = (args) ? args : {};
        this.id = args.id || 0;
        this.user_id = args.user_id || null;
        this.name = args.name || '';
        this.prompt = args.prompt || '';
        this.welcome = args.welcome || null;
        this.is_context = args.is_context || false;
        this.is_sidepanel = args.is_sidepanel || false;
        this.is_default = args.is_default || false;
        this.is_web = args.is_web || false;
        this.is_background = args.is_background || false;
        this.updated_at = moment(args.updated_at).format('Y-M-D') || moment().format('Y-M-D');
        this.created_at = moment(args.created_at).format('Y-M-D') || moment().format('Y-M-D');
    }

    static get data() {
        return _data;
    }

    static takeModule() {
        Module.loading = true
        return m.request({
            method: 'GET',
            url: `${window.BASE_URL}/api/chrome/user/module`,
            headers: {
                "Authorization": "Bearer " + window.JWTAuth,
            },
        }).then((response) => {
            Module.loading = false
            return response
        })
    }
    static unlike(data) {
        Module.loading = true
        return m.request({
            method: 'POST',
            url: `${window.BASE_URL}/api/chrome/user/module/unlike`,
            headers: {
                "Authorization": "Bearer " + window.JWTAuth,
            },
            data:data,
        }).then((response) => {
            Module.loading = false
            return response
        })
    }
    
    save() {
        Module.loading = true
        return m.request({
            method: 'POST',
            url: `${window.BASE_URL}/api/chrome/user/module`,
            headers: {
                "Authorization": "Bearer " + window.JWTAuth,
            },
            data: this
        }).then((response) => {
            Module.loading = false
            return response
        })
    }
    static deleteModule(id) {
        Module.loading = true
        return m.request({
            method: 'DELETE',
            url: `${window.BASE_URL}/api/chrome/user/module`,
            headers: {
                "Authorization": "Bearer " + window.JWTAuth,
            },
            data: {
                id: id,
            }
        }).then((response) => {
            Module.loading = false
            return response
        })
    }
    static deleteDefdult(id) {
        Module.loading = true
        return m.request({
            method: 'DELETE',
            url: `${window.BASE_URL}/api/chrome/user/deleteDefdult`,
            headers: {
                "Authorization": "Bearer " + window.JWTAuth,
            },
            data: {
                id: id,
            }
        }).then((response) => {
            Module.loading = false
            return response
        })
    }

    
}

export default Module